<template>
  <article>
    <el-row><p></p></el-row>
    <el-table
      class="reserveLogTable"
      :data="reserveSOList"
      :span-method="tableSpanMethod"
      border
      height="400px"
      :header-row-style="{ textAlign: 'center' }"
    >
      <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="150">
        <template slot-scope="scope">
          <article v-if="(scope.row.releaseOrderNo || '').toUpperCase() === 'TOTAL'">
            {{ scope.row.releaseOrderNo }}
          </article>
          <el-link v-else @click="openReleasePage(scope.row.releaseID)">
            {{ scope.row.releaseOrderNo }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="SO" label="SO" width="110"></el-table-column>
      <el-table-column prop="SOLine" label="SO LINE" width="100"></el-table-column>
      <el-table-column prop="partNo" :label="$t('pages.wording.partNo')" width="120"></el-table-column>
      <el-table-column prop="partNameCN" :label="$t('pages.wording.partName')" width="120"></el-table-column>
      <el-table-column :label="$t('pages.wording.netWeight')" width="90">
        <template slot-scope="scope">
          {{formatDigitalNumber(scope.row.netWeight) }}
        </template>
      </el-table-column>
      <el-table-column prop="packType" :label="$t('pages.wording.packType')" width="120"></el-table-column>
      <el-table-column :label="$t('pages.wording.packWeight')" width="90">
        <template slot-scope="scope">
          {{formatDigitalNumber(scope.row.packWeight) }}
        </template>
      </el-table-column>
      <el-table-column prop="grossWeight" :label="$t('pages.wording.grossWeight')" width="90">
        <template slot-scope="scope">
          {{formatDigitalNumber(scope.row.grossWeight) }}
        </template>
      </el-table-column>
      <el-table-column prop="unit" :label="$t('pages.wording.unit')" width="120"></el-table-column>
      <el-table-column prop="plantCode" label="Plant Code" width="110"></el-table-column>
    </el-table>
  </article>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"

export default {
  name: "ReserveSOTable",
  props: {
    reserveID: {
      type: Number,
      default: () => -1,
    },
    oaCode: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      reserveSOList: [],
    }
  },
  created() {
    this.getSOTableList()
  },
  methods: {
    formatDigitalNumber(num) {
      return utils.formatDigitalNumber(num)
    },
    getSOTableList() {
      api
        .apiGetSoListBindingWithReserveData(this.reserveID, this.oaCode)
        .then((res) => {
          if (res) {
            this.reserveSOList = res.data
          } else {
            this.reserveSOList = []
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    openReleasePage(releaseID) {
      let data = {
        id: releaseID,
      }
      data["prevPageParams"] = {
        routeName: "PageVendorReleaseOrder",
      }
      this.$router.push({
        name: "PageVendorReleaseOrderInfo",
        params: data,
      })
    },
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0 || row.releaseOrderNo !== this.reserveSOList[rowIndex - 1].releaseOrderNo) {
          return {
            rowspan: row.SoCount,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
  },
  computed: {},
}
</script>

<style scoped>
.reserveLogTable a:hover {
  color: #007bff !important;
}
.reserveLogTable a {
  color: #007bff !important;
}
.reserveLogTable th {
  border-top: 1px solid #ebeef5 !important;
}
</style>
